var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.markdown)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.markdownPage())}})}
var staticRenderFns = []

export { render, staticRenderFns }